var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "50ez0s3w0b",
    width: "116.7%",
    height: "116.7%",
    x: "-8.3%",
    y: "-8.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0.049720091 0 0 0 0 0.162930756 0 0 0 0 0.76452106 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "0qgw79ivaa",
    cx: 24,
    cy: 24,
    r: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1016 -603) translate(990 515) translate(26 88) translate(6 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#147BF9",
    xlinkHref: "#0qgw79ivaa"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#50ez0s3w0b)",
    xlinkHref: "#0qgw79ivaa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.427 37.863l.264-.163.422-.267.45-.29.478-.316.33-.223.341-.234.349-.243.356-.253.363-.263.184-.135.371-.277.188-.142.378-.291.19-.149.382-.304c4.472-3.596 9.323-8.949 8.265-14.694-.584-3.172-3.056-5.765-6.18-6.517-2.537-.61-4.957-.04-6.824 1.28-.267.19-.692.458-1.275.807-.55-.39-.936-.665-1.156-.826l-.082-.063c-1.778-1.439-4.156-2.166-6.727-1.722-3.166.546-5.8 2.972-6.589 6.1-1.223 4.854 1.904 9.704 5.486 13.435l.36.37c.3.304.604.6.907.888l.363.342.181.167.362.328.18.161.359.315.177.154.353.3.348.291.172.142.34.276.331.266.325.255.316.244.455.346.29.216.414.303.384.275c1.014.718 2.36.763 3.419.111z",
    transform: "translate(-1016 -603) translate(990 515) translate(26 88) translate(6 6) rotate(-1 24.26 25.386)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLove);
export default __webpack_public_path__ + "static/media/emoji-love.122f0fba.svg";
export { ForwardRef as ReactComponent };